import React from "react";
import { 
  Container, 
  Navbar, 
  Nav, 
  Button, 
  Badge,
  Dropdown
} from "react-bootstrap";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { FaChartLine, FaBrain, FaFolder, FaPhone, FaSignOutAlt, FaUserCircle } from "react-icons/fa";
import { theme } from "../styles/theme";

export default function Dashboard({ handleLogout }) {
  const navigate = useNavigate();
  const location = useLocation();

  const logout = () => {
    handleLogout();
    navigate("/login", { replace: true });
  };

  const navItems = [
    { path: "/dashboard/stats", icon: <FaChartLine className="me-2" />, label: "Statistiques" },
    { path: "/dashboard/gptPrompt", icon: <FaBrain className="me-2" />, label: "GPT Prompts" },
    { path: "/dashboard/gestion-categories", icon: <FaFolder className="me-2" />, label: "Catégories" },
    { path: "/dashboard/transcriptions/calls", icon: <FaPhone className="me-2" />, label: "Appels" }
  ];

  const isActive = (path) => {
    return location.pathname === path ? "active" : "";
  };

  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div 
          className="d-none d-lg-flex flex-column p-3 text-white" 
          style={{ 
            width: "250px", 
            backgroundColor: theme.colors.primary,
            boxShadow: theme.shadows.md,
            position: 'fixed',
            top: '0',
            bottom: 0,
            left: 0,
            zIndex: 1020
          }}
        >
          <div 
            className="d-flex align-items-center mb-4 p-2 rounded"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/dashboard/stats")}
          >
            <div className="me-2">🎧</div>
            <h4 className="mb-0">Monitoring AI</h4>
          </div>
          
          <hr className="bg-light" />
          
          <Nav className="flex-column">
            {navItems.map((item, index) => (
              <Nav.Link
                key={index}
                onClick={() => navigate(item.path)}
                className={`d-flex align-items-center mb-2 p-2 rounded text-white ${isActive(item.path)}`}
                style={{
                  transition: theme.transition.default,
                  backgroundColor: isActive(item.path) ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
                  borderLeft: isActive(item.path) ? `4px solid ${theme.colors.white}` : '4px solid transparent'
                }}
              >
                {item.icon}
                {item.label}
                {item.path === "/dashboard/transcriptions/calls" && (
                  <Badge bg="light" text="primary" className="ms-auto">
                    Nouveau
                  </Badge>
                )}
              </Nav.Link>
            ))}
          </Nav>
          
          <div className="mt-auto">
            <Button 
              variant="outline-light" 
              className="w-100 d-flex align-items-center justify-content-center"
              onClick={logout}
            >
              <FaSignOutAlt className="me-2" />
              Déconnexion
            </Button>
          </div>
        </div>

        {/* Mobile Header */}
        <div className="d-lg-none w-100" style={{ 
          position: 'fixed', 
          top: '0', 
          zIndex: 1020,
          width: '100%'
        }}>
          <Navbar bg="dark" variant="dark" expand="lg" className="shadow-sm">
            <Container fluid>
              <Navbar.Brand 
                className="d-flex align-items-center" 
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/dashboard/stats")}
              >
                🎧 Monitoring AI
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="mobile-navbar" />
              <Navbar.Collapse id="mobile-navbar">
                <Nav className="me-auto">
                  {navItems.map((item, index) => (
                    <Nav.Link 
                      key={index} 
                      onClick={() => navigate(item.path)}
                      className={isActive(item.path)}
                    >
                      {item.icon} {item.label}
                    </Nav.Link>
                  ))}
                  <Nav.Link onClick={logout}>
                    <FaSignOutAlt className="me-2" />
                    Déconnexion
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </div>

        {/* Main Content */}
        <div className="flex-grow-1" style={{ 
          marginLeft: '250px',
          padding: '20px',
          backgroundColor: theme.colors.light,
          minHeight: '100vh'
        }}>
          <main className="p-3 p-md-4" style={{ 
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: theme.shadows.sm,
          }}>
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}